import { createReducer, on } from '@ngrx/store';
/* eslint import/no-cycle: [2, { ignoreExternal: true }] */
import { PagesRoutes } from 'src/app/pages/page.routes';
import { environment as env } from 'src/environments/environment';
import { MultiProductRoutes } from 'src/app/multi_product/mp.routes';
import { setSteps, setCurrentStep, setCompleteStep } from './wizard.actions';
import { QuoteRoutes } from '../quote.routes';
import { LocalStorageService } from 'src/app/common/services/local-storage.service';

const routesPE = QuoteRoutes.ROUTES;

const routesBR = PagesRoutes.ROUTES;

const routesMP = MultiProductRoutes.ROUTES;

const routes = env.COUNTRY === 'pe' ? routesPE.Steps : env.COUNTRY === 'br' ? routesBR.Flow.Traditional.Steps : routesMP.Steps;

const localStorageService = new LocalStorageService();

export interface Step {
  path?: string;
  fullPath?: string;
  index?: number;
  isComplete?: boolean;
  img?: string;
}

export interface State {
  steps: Step[];
  currentStep: Step;
}

export const initialState: State = {
  steps: localStorageService.get('steps') || Object.values(routes),
  currentStep: {},
};

export const wizardReducer = createReducer(
  initialState,

  on(setSteps, (state, { steps }) => ({ ...state, steps })),
  on(setCurrentStep, (state, { currentStep }) => ({ ...state, currentStep })),
  on(setCompleteStep, ({ steps, currentStep }, { index }) => {
    const newSteps = steps.map((step, i) => {
      if (index === i) {
        return {
          ...step,
          isComplete: true,
        };
      }
      return step;
    });

    return { steps: newSteps, currentStep };
  })
);
